<template lang="pug">
  v-container#login.fill-height.justify-center(tag="section")
    v-row(justify="center")
      base-material-snackbar(v-model="snackbar" type="success" v-bind="{[parsedDirection[0]]: true, [parsedDirection[1]]: true}")
        h4.font-weight-bold
          | Correo enviado. Hemos enviado un link de confirmación a su correo
      v-snackbar(v-model='snackbarError.snackbar' :color='snackbarError.color' top :timeout='snackbarError.timeout')
        | {{ snackbarError.text }}
        v-btn(dark='' text='' @click='snackbarError.snackbar = false')
          | {{$t('payment.general.close')}}
      v-col
        v-slide-y-transition(appear="")
          v-card.login-card.pa-3.pa-md-6.mx-auto(light="" elevation="12" style="max-width: 350px;" )
            v-layout.column.justify-center.align-center
              img(:src='logo').login__logo.ma-auto
              v-btn(v-show='$route.name !== "Login"' fab small color="secondary__blue" @click="$emit('close')" style="position: absolute; z-index: 999; top: -10px; right: -10px;")
                v-icon.rounded mdi-close
            v-row.register__form.mt-2
            v-card-text.text-center
              v-text-field.rounded(v-model="account.email" color="secondary" @keyup.enter="login" label="Email..." solo dense  prepend-inner-icon="mdi-email"  type="email")
              v-text-field.rounded(v-if="!recovery" v-model="account.password" @keyup.enter="login" color="secondary" solo dense label="Contraseña..." prepend-inner-icon="mdi-lock-outline" :append-icon="'mdi-backup-restore'" @click:append="recovery = !recovery" type="password")
              v-row
                v-col.text-center
                  v-btn( small color="primary"  :disabled="isLoading" @click="login" v-if="!recovery")
                    | Ingresar
                  v-btn(  color= "primary" :disabled="isLoading" @click="recoveryPass" v-if="recovery")
                    | Recuperar
                v-col(cols="12" v-if="!recovery" ).text-center
                  a(text large color='success' @click="toggleRecoveryMode") Olvidé mi contraseña
              v-row(v-if="recovery").text-center
                v-col.text-center
                  a( flat @click="recovery = !recovery")
                    |Ingresar
              a(v-if='userType === "business"' href="#/pages/register").display-1 No tienes una cuenta?, registrate Aquí
              a(v-else @click="$emit('switchDialog')").display-1 No tienes una cuenta?, registrate Aquí
              v-col(v-show="!recovery")
                v-col.display-1 ó Ingresa con tus redes
                v-col().text-center
                  v-btn.mx-2(fab="" dark="" small="" color="cyan" @click="loginProvider('google')")
                    v-icon(dark="") mdi-google
                  // v-btn.mx-2(fab="" dark="" small="" color="cyan" @click="loginProvider('facebook')")
                    v-icon(dark="") mdi-facebook
                  #firebaseui-auth-container.d-none
</template>

<script>
  import logo from '@/assets/logo-2.png'
  import 'firebaseui/dist/firebaseui.css'
  import firebase from 'firebase'
  const firebaseui = require('firebaseui')
  export default {
    name: 'PagesLogin',
    components: {
      FeatureCarousel: () => import('./component/FeatureCarousel'),
    },
    props: {
      userType: {
        type: String,
        default: function () {
          return 'business'
        },
      },
    },

    data: () => ({
      logo: logo,
      recovery: false,
      snackbar: false,
      direction: 'bottom center',
      errMsg: '',
      account: {
        email: '',
        password: '',
      },
      snackbarError: {
        color: '',
        snackbar: false,
        text: '',
        timeout: 6000,
      },
      socials: [
        {
          href: '#',
          icon: 'mdi-facebook-box',
        },
        {
          href: '#',
          icon: 'mdi-twitter',
        },
        {
          href: '#',
          icon: 'mdi-github-box',
        },
      ],
    }),
    computed: {
      isAuth () {
        return !!this.$store.state.users.user
      },
      isLoading () {
        return this.$store.state.users.isLoading
      },
      parsedDirection () {
        return this.direction.split(' ')
      },
    },
    created () {
      // firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-google firebaseui-id-idp-button
      // const vm = this
      /* firebase.auth().onAuthStateChanged(function (currentUser) {
        try {
          currentUser.getIdTokenResult().then((idTokenResult) => {
            vm.$store.dispatch('users/setCookie', idTokenResult.token)
            const path = vm.userType === 'business' ? '/dashboard' : ''
            // console.log(currentUser)
            if (currentUser) {
              if (currentUser.displayName === 'collaboratorCreatedInAdmin') {
                // console.log('redireccion', path)
                // console.log('user', vm.$store.state.users.user)
                vm.$router.replace(path).catch(err => {
                  // console.log(err)
                })
                vm.$emit('close')
              } else {
                const { email, uid } = currentUser
                vm.$store.commit('users/SET_USER', { email, uid })
                vm.$router.replace(path).catch(err => {
                  // console.log(err)
                })
                vm.$emit('close')
              }
            }
          })
        } catch (error) {
          // console.log(error)
        }
      }) */
      // this.$store.dispatch('loading/setLoading',false);
    },
    mounted () {
      const vm = this
      const uiConfig = {
        signInFlow: 'popup',
        signInSuccessUrl: vm.userType === 'business' ? '#/dashboard/' : '#/',
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        ],
        callbacks: {
          signInSuccessWithAuthResult: function (authResult, redirectUrl) {
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            // console.log('exitoso', authResult)
            vm.$emit('close')
            return true
          },
        },
      }
      let ui = firebaseui.auth.AuthUI.getInstance()
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth())
      }
      ui.start('#firebaseui-auth-container', uiConfig)
      // const ui = new firebaseui.auth.AuthUI(firebase.auth())
    },
    methods: {
      setDataNotification (ban, color, text) {
        this.snackbarError.snackbar = ban
        this.snackbarError.color = color
        this.snackbarError.text = text
      },
      toggleRecoveryMode () {
        this.recovery = !this.recovery
      },
      loginProvider (provider) {
        switch (provider) {
          case 'facebook':
            document.getElementsByClassName('firebaseui-idp-facebook')[0].click()
            break
          case 'google':
            document.getElementsByClassName('firebaseui-idp-google')[0].click()
            break
        }
      },
      login (e) {
        const vm = this
        e.preventDefault()
        // console.log('aqui')
        vm.$store.dispatch('users/login', this.account)
          .then(function (res) {
            // console.log(res)
            const path = vm.userType === 'business' ? '/dashboard' : ''
            vm.$router.replace(path).catch(err => {
              console.log(err)
            })
            vm.$emit('close')
            // vm.$router.replace('summary')
          })
          .catch(error => {
            // console.log(error.code)
            vm.errMsg = error.code
            if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
              vm.errMsg = 'Email o contraseña invalido'
            }
            this.setDataNotification(true, 'error', vm.errMsg)
          })
      },
      recoveryPass (e) {
        const vm = this
        e.preventDefault()
        this.$store.dispatch('users/forgotPass', this.account)
          .then(() => {
            vm.recovery = false
            vm.snackbar = true
          })
          .catch(error => {
            vm.errMsg = error.code // solo para que vue compile
            vm.errMsg = 'Email invalido'
            this.setDataNotification(true, 'error', vm.errMsg)
          })
      },
    },
  }
</script>
<style lang="scss">
  .login__logo{
    max-height: 20px;
  }
  .login-card{
    border-radius: 25px !important;
  }
</style>
